import { BaseTextFieldProps } from "@mui/material";
import { AlertColor } from "@mui/material/Alert";
import { Ref } from "react";

// TypeScript type for the function parameters
type InputType = "recommend" | "user_type" | `starter_${number}` | "news_prompt";
type statusType = "idle" | "loading" | "succeeded" | "failed";
type CloseModalFunction = () => void;
type DispatchFunction = (action: { type: string; payload? }) => void;
type TextFieldOnChangeHandler = (
  event: React.ChangeEvent<HTMLInputElement>
) => void;

export interface RenderPhoneFieldFunc {
  label: string;
  error: string;
  value: string;
  onChange: (value: string) => void;
}

export interface RenderTextFieldFunc {
  label: string;
  value: string;
  onChange: TextFieldOnChangeHandler;
  error: string;
  type?: string;
}

export type ValidationFormFunc = (
  email: string,
  password: string
) => ValidationResult;

export type PostMessagesFunction = (
  text: string,
  input_type: InputType,
  token?: string,
  attachments?: MessageAttachments
) => void;

export type OauthSignInFucntion = (
  closeModal: CloseModalFunction,
  dispatch: DispatchFunction,
  navigate?: (path: string) => void
) => void;

export type sendMessageFunction = (text: string, input_type: InputType, attachments?: MessageAttachments) => void;
export interface DefaultSignInProps {
  emailValue: string;
  setFlow: (flow: number) => void;
  setOpen?: (open: boolean) => void;
}
// Define a type for individual chat message
export interface SubmenuItemProps {
  item: {
    sessionId: string;
    title?: string;
  };
  clearAllChatData: () => void;
  chatRef?: Ref<HTMLDivElement>;
}
export interface ChatMessage {
  date: string;
  title: string;
  sessionId: string;
}
export interface SettingsModalInterface {
  open: boolean;
  setOpen: (isSettingsModalOpen: boolean) => void;
  generalActive: boolean;
  setGeneralActive: (general: boolean) => void;
  handleProfileMenuClose: () => void;
  clearAllChatData: () => void;
  handleSignOut: () => void;
}
export interface PreferencesModalInterface {
  open: boolean;
  handleClose: () => void;
}
export interface ValidateUserState {
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
  isValid: boolean;
}

export interface DeleteUserArg {
  user_id: string | null | undefined;
}
export interface SamplePrompt {
  description: string;
  title: string;
  type: string;
}

type RecommendedStocksTypes = "quick_trades" | "top_picks";
type RecommendedOptionsTypes = "hot_trades" | "market_movers";

export interface RecommendedPrompts {
  stocks: {
    [key in RecommendedStocksTypes]: {
      query: string;
    }[]
  };
  options: {
    [key in RecommendedOptionsTypes]: {
      query: string;
    }[]
  };
}
export interface AccordianInterface {
  title: React.ReactNode;
  description: React.ReactNode;
}
// Define a type for the slice state

export interface PromptsState {
  prompts: SamplePrompt[];
  status: statusType;
  error: string | null;
}
export interface RecommendedPromptsState {
  prompts: RecommendedPrompts;
  promptSelected: string | null;
  status: statusType;
  error: string | null;
}

export interface ChatState {
  messages: ChatMessage[];
  tempMessages: ChatMessage[];
  status: statusType;
  error: string | null;
}

export interface DeleteChatState {
  status: statusType;
  error: string | null;
}

export interface changeSubArg {
  price_id?:
    | string
    | null
    | undefined
    | "TradeGpt-Premium-USD-Monthly"
    | "TradeGpt-Pro-USD-Monthly";
  cancel: boolean;
}

export interface fetchUserArg {
  source?: string | null | undefined;
  cje?: string | null | undefined;
}

export interface fetchUserPrefArg {
  userId: string | null | undefined;
  preferences?: Preference;
}

export interface changeSubState {
  checkoutObject;
  status: statusType;
  error: string | null;
}

export interface PastChatState {
  pastMessages: ChatMessage[];
  status: statusType;
  error: string | null;
}
export interface ActivePlanState {
  plan: {
    promptsLeft: number;
    subscription_type: "Free" | "Pro" | "Premium";
    subscription;
  };
  status: statusType;
  error: string | null;
}
export interface AllPlanState {
  plans: unknown[];
  status: statusType;
  error: string | null;
}

export interface AuthModalState {
  isOpen: boolean;
  type: "signin" | "signup" | null;
  disableClose?: boolean;
}
export interface UserState {
  user: User;
  status: statusType;
  error: string | null;
  showToSModal: boolean;
  isManualSignUp: boolean;
  isNewUser: boolean;
  isAcknowledged: boolean;
  authModal: AuthModalState;
}
export interface UserPreferenceState {
  userId?: string;
  preferences: Preference | null;
  status: string;
  error: string | null;
  hasOpenedModal: boolean | null;
}
export interface TokenState {
  token: string;
  status: statusType;
  error: string | null;
}

export interface updateFirestoreState {
  firestoreFields;
  status: statusType;
  error: string | null;
}
// Define a type for the thunk argument
export interface FetchChatsArg {
  userId: string | undefined | null;
}
export interface FetchSessionArg {
  sessionId: string | undefined | null;
}
export interface FetchPlanArg {
  userId: string | undefined | null;
}

export interface SendFeedbackArg {
  message_id: string;
  is_thumbs_up: boolean;
  feedback_text?: string;
  reason_cat?: string[];
}

export interface RootState {
  finchat;
  FinchatGPT: {
    finchatMessage; // Replace 'any' with the actual type
  };
  auth: {
    loading: boolean;
    currentUser;
  };
  chat: ChatState;
  session;
  prompts: PromptsState;
  sharedSession;
}
export interface MessageInputProps {
  sessionId: string;
  handleSendMessage: sendMessageFunction;
  setMessages;
  handleCancel: () => void;
  showPrompts: boolean;
  handlePromptSelect: (prompt: string, position: number) => void;
}
export interface UserAuthData {
  email: string;
  password: string;
  displayName: string;
  phoneNumber: string;
  landing?: boolean;
}
export interface FormData {
  email: string;
  name: string;
  phoneNumber: string;
  password: string;
}

export interface ValidationResult {
  valid: boolean;
  errors;
}
export interface TypingAnimationProps {
  text: string;
  speed?: number;
  onComplete?: () => void;
  components?: {
    [key: string]: React.ComponentType<React.AnchorHTMLAttributes<HTMLAnchorElement>> | ((props: React.AnchorHTMLAttributes<HTMLAnchorElement>) => JSX.Element);
  };
}
export interface UserArg {
  token: string;
  isMobileApp?: boolean;
}

export interface FirestoreArg {
  firestoreFields?;
  source?: string;
}
export interface User {
  accessToken: string;
  userId: string | null;
  phoneNumber: string;
  feature_flags: Record<string, unknown> | string;
  country: string;
  state: string;
  email: string;
  display_name?: string;
  displayName?: string;
  name: string;
  ip: string;
  sign_in_attempts: number | string;
  photoURL: string | null;
}
export interface Message {
  message_id?: string;
  chart_data: unknown[]; // Replace 'any' with a more specific type if possible
  chart_flag: boolean;
  chat_id: string;
  input: string;
  output: string;
  isBot: boolean;
  outputLoading: boolean;
  attachments?: MessageAttachments;
  list_of_tickers: string[];
}
export interface Preference {
  tradingFocus: "equity" | "options" | "any";
  riskAppetite: "high" | "medium" | "small" | "any";
}

export interface ChatPreference {
  information_richness: string;
  expertise_level: string;
  market_cap: string;
  include_sectors: Array<string>;
  exclude_sectors: Array<string>;
};
export interface MUIPhoneProps extends BaseTextFieldProps {
  value: string;
  onChange: (phone: string) => void;
}

export interface ChatWindowProps {
  sessionId: string;
  messages: Partial<Message>[];
  isMobile: boolean;
  isTablet: boolean;
  isUserSignedIn: boolean;
  shareModal: boolean;
  setShareModal: (boolean) => void;
  handleSendMessage: (msg: string) => void;
}

export interface PlanCardProps {
  planName: string;
  price: string;
  billingCycle: string;
  prompts: number | string;
  buttonText: string;
  buttonType: "primary" | "default" | "disabled";
  mostPopular?: boolean;
  id?: string;
}

export interface SidebarProps {
  isMobile: boolean;
  drawerOpen: boolean;
  setDrawerOpen: (bool: boolean | ((bool: boolean) => boolean)) => void;
}

export interface SeriesItem {
  type: string;
  name: string;
  data: Array<unknown>;
  tooltip?;
}

export interface MessageAttachments {
  images?: {
    image_url: string;
    file_id: string;
  }[];
}
export interface FinchatMessagePayload {
  input: string;
  chat_id: string;
  session_id: string;
  user_id: string;
  accessToken: string;
  input_type: InputType;
  attachments?: MessageAttachments;
  preferences: ChatPreference;
}

export interface FinchatResponsePayload {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chart_data: any[];
  chat_id: string;
  chart_flag: boolean;
  session_id: string;
  list_of_tickers: string[];
}

export interface UserPreferencePayload {
  preferences: Preference;
}

export interface NotificationSnackbarProps {
  open: boolean;
  onClose: () => void;
  message: string;
  title?: string;
  severity: AlertColor; // Use AlertColor type from Material-UI
  horizontal: "right" | "center";
}

export interface NotificationState {
  open: boolean;
  message: string;
  title?: string;
  severity: "success" | "error" | "info" | "warning";
  horizontal: "right" | "center";
}

export interface IntroPromoState {
  show: boolean;
}

export interface GeneralModalProps {
  open: boolean;
  handleClose: () => void;
  session_id?: string;
}

export interface Point {
  id: number;
  text: string;
}

export interface ChangeLog {
  id: string;
  title: string;
  date: string;
  description: string;
  version: string;
  version_type: string;
  categories: string[];
  status: string;
  is_public_visible: boolean;
}

export interface ChangeLogsState {
  lastViewed?: string;
  logs: ChangeLog[];
  isLoading: boolean;
}

export type Ticker = {
  ticker: string;
  seq?: string;
  name?: string;
};

export type TickerInfo = {
  name?: string;
  prev_close_price?: number | null;
  last_price?: number | null;
};

export type LLMSummaryNews = {
  ticker: string;
  summarized_headline: string;
  create_timestamp: string;
};

export type Summary = {
  agg_id: number;
  summarized_headline: string;
  create_timestamp: string;
  events?: Event[];
  reaction?: string | null;
};

export type Event = {
  headline: string;
  news_timestamp: string;
  news_url: string;
};

export enum FeedbackTypes {
  THUMBS_UP = "THUMBS_UP",
  THUMBS_DOWN = "THUMBS_DOWN",
}

export type MainLayoutType = {
  isSidebarExpanded: boolean;
  setIsSidebarExpanded: (value: boolean) => void;
};

export type AlertMessageType = {
  message: string;
  severity: "success" | "error";
};
